function initSearch() {
	
	const debounce_delay = 250;
	
	const search_forms = document.querySelectorAll('form.search');
	search_forms.forEach((search_form) => {
		
		const input = search_form.querySelector('input[name=q]');
		
		const results_parent = search_form;
		const results = document.createElement('ul');
		results.classList.add('results');
		results_parent.append(results);
		
		let timer = null;
		let controller = null;
		
		function autocomplete() {
			clearTimeout(timer);
			
			if(controller) {
				controller.abort();
				controller = null;
			}
			
			const q = input.value.trim();
			if(q.length < 2) {
				results.style.display = 'none';
				return;
			}
			
			timer = setTimeout(async () => {
				
				controller = new AbortController();
				
				try {
					const response = await fetch('/api/search.php?q='+encodeURIComponent(q), {
						signal: controller.signal,
						headers: {
							'Accept': 'application/json'
						}
					});
					if(!response.ok) {
						throw new Error('HTTP '+response.status);
					}
					const data = await response.json();
					if(!Array.isArray(data)) {
						throw new Error('Unexpected response');
					}
					
					if(data.length > 0) {
						results.innerHTML = '';
						data.forEach((item)=>{
							const li = document.createElement('li');
							results.append(li);
							const a = document.createElement('a');
							let desc = item.name;
							if(item.type_name.length > 0) desc += ' <span class="small typename">'+item.type_name+'</span>';
							if(item.desc.length > 0) desc += ' <span class="small">'+item.desc+'</span>';
							a.innerHTML = desc;
							a.setAttribute('href', item.permalink);
							
							// up down key nav
							a.addEventListener('keydown', (e)=>{
								let first = (a.parentElement === a.parentElement.parentElement.firstElementChild);
								let last = (a.parentElement === a.parentElement.parentElement.lastElementChild);
								if(e.key === 'ArrowDown') {
									e.preventDefault();
									if(!last) a.parentElement.nextElementSibling.querySelector('a').focus();
									return;
								}
								if(e.key === 'ArrowUp') {
									e.preventDefault();
									if(first) input.focus();
									else a.parentElement.previousElementSibling.querySelector('a').focus();
									return;
								}
							});
							
							li.append(a);
							
						});
						results.style.display = 'block';
					}
					else {
						results.style.display = 'none';
					}
					
				} catch (error) {
					if(error.name !== 'AbortError') {
						console.error('Autocomplete error: '+error);
					}
				}
				
			}, debounce_delay);
		}
		
		input.addEventListener('input', autocomplete);
		input.addEventListener('focus', autocomplete);
		
		// tab focus to results if pressing down key
		input.addEventListener('keydown', (e)=>{
			if(e.key === 'ArrowDown') {
				e.preventDefault();
				let firstResult = results.querySelector('a');
				if(firstResult) firstResult.focus();	
			}
		});
		
		// close with esc
		document.addEventListener('keydown', (e)=>{
			if(e.key === 'Escape') {
				results.style.display = 'none';
			}
		});
		
		// close with click outside
		document.addEventListener('click', (e) => {
			if(results.style.display === 'block') {
				if(!results.contains(e.target)) {
					results.style.display = 'none';
				}
			}
		});
		
		// close when focus leaves parent
		/*
		results_parent.addEventListener('focusout', (e)=>{
			const next = e.relatedTarget;
			if(!results_parent.contains(next)) {
				results.style.display = 'none';
			}
		});
		*/
		
		// close when focus leaves parent (using pointerdown outside instead of focusout due to iOS issues)
		document.addEventListener('pointerdown', (e)=>{
			if(results.style.display === 'block') {
				if(!results_parent.contains(e.target)) {
					results.style.display = 'none';
				}
			}
		});
		
		// only submit if content
		search_form.addEventListener('submit', (e) => {
			input.value = input.value.trim();
			if(input.value.length === 0) e.preventDefault();
		});
		
	});
	
	

}
initSearch();

  